import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

export interface Notification {
  id: string;
  title: string;
  message: string;
  type: string;
  isRead?: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface Announcement {
  id: string;
  title: string;
  message: string;
  type: string;
  createdAt: string;
  updatedAt: string;
}

// 공지사항 조회
export const getAnnouncements = async (page = 1, limit = 20): Promise<Announcement[]> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/notifications/announcements`, {
      params: { page, limit }
    });
    return response.data;
  } catch (error) {
    console.error('공지사항 조회 오류:', error);
    throw error;
  }
};

// 개인 알림 조회
export const getNotifications = async (token: string, page = 1, limit = 20, unreadOnly = false): Promise<Notification[]> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/notifications`, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: { page, limit, unreadOnly }
    });
    return response.data;
  } catch (error) {
    console.error('알림 조회 오류:', error);
    throw error;
  }
};

// 알림 읽음 처리
export const markNotificationAsRead = async (token: string, notificationId: string): Promise<void> => {
  try {
    await axios.patch(`${API_BASE_URL}/notifications/${notificationId}/read`, {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  } catch (error) {
    console.error('알림 읽음 처리 오류:', error);
    throw error;
  }
};

// 모든 알림 읽음 처리
export const markAllNotificationsAsRead = async (token: string): Promise<void> => {
  try {
    await axios.patch(`${API_BASE_URL}/notifications/mark-all-read`, {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  } catch (error) {
    console.error('모든 알림 읽음 처리 오류:', error);
    throw error;
  }
};

// 읽지 않은 알림 개수 조회
export const getUnreadNotificationCount = async (token: string): Promise<number> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/notifications/unread-count`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data.count;
  } catch (error) {
    console.error('읽지 않은 알림 개수 조회 오류:', error);
    return 0;
  }
};

// 공지사항 생성 (관리자용)
export const createAnnouncement = async (token: string, title: string, message: string): Promise<Announcement> => {
  try {
    const response = await axios.post(`${API_BASE_URL}/notifications/announcements`, {
      title,
      message
    }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('공지사항 생성 오류:', error);
    throw error;
  }
};
